import styled from "styled-components";

export const CMLegendContainer = styled.div(props => ({
    display: 'flex',
}));

export const CMLegend = styled.div(props => ({
    margin: '1rem 2% 1rem 0',
    display: 'flex',
    alignItems: 'center',
    fontSize: props.theme.fontSizes.p,
    color: props.theme.palette.gray["800"],

    "& > div": {
        height: props.iconSize, 
        width: props.iconSize, 
        backgroundColor: props.color, 
        borderRadius: '50%', 
        marginRight: '8px'
    },
}));

export const CMLineChart = styled.div(props => ({
    width: '100%', 
    height: '300px',
    
    '& svg': {
        width: '100% !important',
        height: '100% !important'
    }
}));